import './node_modules/bootstrap/dist/css/bootstrap.min.css';

import LeadBrandContextProvider from './src/context/leadBrand.context';
import React from 'react';
import { posthog } from 'posthog-js';

export const onClientEntry = () => {
  const hashParams = new URLSearchParams(window.location.hash.substring(1));
  const distinctId = hashParams.get('distinct_id');
  const sessionId = hashParams.get('session_id');

  posthog.init(process.env.GATSBY_POSTHOG_API_KEY, {
    api_host: process.env.GATSBY_POSTHOG_HOST || 'https://us.i.posthog.com',
    capture_pageview: false,
    ...(distinctId && sessionId
      ? { bootstrap: { distinctID: distinctId, sessionID: sessionId } }
      : {}),
  });
};

export const wrapRootElement = ({ element }) => {
  return <LeadBrandContextProvider>{element}</LeadBrandContextProvider>;
};
